import { render, staticRenderFns } from "./AdminProgramInformation.vue?vue&type=template&id=951eacf4&scoped=true"
import script from "./AdminProgramInformation.vue?vue&type=script&lang=js"
export * from "./AdminProgramInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951eacf4",
  null
  
)

export default component.exports